
  import { Component, Vue, Watch } from 'vue-property-decorator';
  import { IScheduleItem, JobScheduleItem } from './ScheduleModels';
  import toJobItemTypeFormatter from '@/filters/jobitemtype.formatter';
  import * as ColorUtils from '@/utilities/color.utils';

  @Component({
    props: {
      block: {
        type: Object as () => IScheduleItem,
        required: true
      }
    },
    filters: {
      toJobItemType: toJobItemTypeFormatter
    }
  })
  export default class ScheduleCard extends Vue {
    get networkStyle() {
      const darkColor: string = ColorUtils.lightenDarkenColor(this.$props.block.networkHexColor, -80);
      return { background: this.$props.block.networkHexColor, color: '#FFFFFF', border: darkColor + ' 1px solid' };
    }

    get showJobItemName(): boolean {
      if (this.$props.block.jobItemName === this.$props.block.serviceType) {
        return false;
      }
      return true;
    }

    private onAssignEmployeeRequested() {
      this.$emit('job-schedule-item-assign-employee-requested', this.$props.block);
    }

    private onRescheduleJobItemRequested() {
      this.$emit('job-schedule-item-reschedule-requested', this.$props.block);
    }

    private onCancelJobItemRequested() {
      this.$emit('job-item-cancel-requested', this.$props.block);
    }
  }
